const PENDING_KEY = 'sw_customer_referral_coupon';
const REFERRAL_SOURCE = 'customer_referral';
const COUPON_PATTERN = /^[A-Z0-9_-]{4,64}$/;

function normalizeCoupon(value: string | null | undefined): string | null {
  const coupon = String(value ?? '').trim().toUpperCase();
  return COUPON_PATTERN.test(coupon) ? coupon : null;
}

export function referralCouponFromSearch(search: string): string | null {
  const params = new URLSearchParams(search);
  if (params.get('coupon_source') !== REFERRAL_SOURCE) return null;
  return normalizeCoupon(params.get('coupon'));
}

export function withoutReferralCouponParams(pathAndQuery: string): string {
  const url = new URL(pathAndQuery, 'https://shop.invalid');
  url.searchParams.delete('coupon');
  url.searchParams.delete('coupon_source');
  return `${url.pathname}${url.search}${url.hash}`;
}

export function rememberReferralCoupon(coupon: string): void {
  const normalized = normalizeCoupon(coupon);
  if (!normalized || typeof sessionStorage === 'undefined') return;
  try { sessionStorage.setItem(PENDING_KEY, normalized); } catch { /* ignore */ }
}

export function pendingReferralCoupon(): string | null {
  if (typeof sessionStorage === 'undefined') return null;
  try { return normalizeCoupon(sessionStorage.getItem(PENDING_KEY)); } catch { return null; }
}

export function forgetReferralCoupon(): void {
  if (typeof sessionStorage === 'undefined') return;
  try { sessionStorage.removeItem(PENDING_KEY); } catch { /* ignore */ }
}
